import React, { Fragment, useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { backend } from "../../api";
import {
  CircularProgress,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "react-toastify/dist/ReactToastify.css";
import PageBanner from "../PageBanner";

const VerifyAccount = () => {
  const { token } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("/dashboard");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const currentUrl = queryParams.get("currentUrl");
    if (currentUrl) {
      setRedirectUrl(currentUrl);
    }

    const verifyAccount = async () => {
      try {
        const response = await backend.post("/payment-method/verify-account", {
          token,
        });

        if (response.status === 200) {
          toast.success(response.data.message);
          setIsVerified(true);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error verifying account:", error.message);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast.error(error.response.data.message);
          setIsVerified(false);
          setErrorMessage(error.response.data.message);
        } else {
          toast.error("Verification failed. Please try again.");
          setErrorMessage("Verification failed. Please try again.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    verifyAccount();
  }, [token, location.search]);

  console.log(decodeURIComponent(redirectUrl));

  const redirectToPreviousPage = () => {
    history.replace(decodeURIComponent(redirectUrl));
  };

  return (
    <Fragment>
      <ToastContainer />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <PageBanner
          title="Account Verification"
          image="/assets/images/bg4.jpg"
        />
        <Card
          style={{
            maxWidth: "800px",
            width: "100%",
            textAlign: "center",
            background: isVerified ? "#e8f5e9" : "#ffebee",
            marginTop: "20px",
          }}
        >
          <CardContent>
            {isLoading ? (
              <>
                <CircularProgress />
                <Typography variant="h6" mt={2}>
                  Verifying your account, please wait...
                </Typography>
              </>
            ) : isVerified ? (
              <>
                <CheckCircleIcon
                  style={{
                    fontSize: 80,
                    color: "#4caf50",
                    marginBottom: "16px",
                  }}
                />
                <Typography
                  variant="h4"
                  style={{ color: "#388e3c", marginBottom: "16px" }}
                >
                  Account Verified!
                </Typography>
                <Typography variant="body1" style={{ marginBottom: "24px" }}>
                  Your account has been successfully verified.
                </Typography>
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<ArrowBackIcon />}
                  onClick={redirectToPreviousPage}
                  style={{ borderRadius: "8px" }}
                >
                  Go Back
                </Button>
              </>
            ) : (
              <>
                <ErrorIcon
                  style={{
                    fontSize: 80,
                    color: "#d32f2f",
                    marginBottom: "16px",
                  }}
                />
                <Typography
                  variant="h4"
                  style={{ color: "#b71c1c", marginBottom: "16px" }}
                >
                  Verification Failed!
                </Typography>
                <Typography
                  variant="body1"
                  style={{ marginBottom: "24px", color: "#b71c1c" }}
                >
                  {errorMessage ||
                    "The verification link is invalid or expired. Please contact support for assistance."}
                </Typography>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<ArrowBackIcon />}
                  onClick={redirectToPreviousPage}
                >
                  Go Back
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </Box>
    </Fragment>
  );
};

export default VerifyAccount;
